'use strict';



export function markupNotRequest() {
      return `<li class="gallery__item--requst">
      </li>`;
    };